// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"194":"component---src-pages-resume-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"194":"b6eda39475b29c08f281","245":"e5633fa3ea25924ae065","453":"fbb26f6acbf134d232fd"}[chunkId] + ".js";
};